import { configureStore } from '@reduxjs/toolkit';
import NotesReducer from './apps/notes/NotesSlice';
import CustomizerReducer from './customizer/CustomizerSlice';
import ChatsReducer from './apps/chat/ChatSlice';
import ContactsReducer from './apps/contacts/ContactSlice';
import EmailReducer from './apps/email/EmailSlice';
import TicketReducer from './apps/ticket/TicketSlice';
import IntegracoesReducer from './apps/integracoes/IntegracoesSlice';
import OnboardingReducer from './apps/onboarding/OnboardingSlice';
import AlertasReducer from './apps/alertas/AlertasSlice';
import CobrancaReducer from './apps/cobranca/CobrancaSlice';
import RecomendacaoReducer from './apps/recomendacao/RecomendacaoSlice';
import DashboardPreditivoReducer from './apps/dashboardPreditivo/DashboardPreditivoSlice';

export const store = configureStore({
  reducer: {
    customizer: CustomizerReducer,
    notesReducer: NotesReducer,
    chatReducer: ChatsReducer,
    contactsReducer: ContactsReducer,
    emailReducer: EmailReducer,
    ticketReducer: TicketReducer,
    integracoesReducer: IntegracoesReducer,
    onboardingReducer: OnboardingReducer,
    alertasReducer: AlertasReducer,
    cobrancaReducer: CobrancaReducer,
    recomendacaoReducer: RecomendacaoReducer,
    dashboardPreditivoReducer: DashboardPreditivoReducer,
  },
});

export default store;
